import Solution from "./solution";
// import compare from "../../Utils/compare";

const testCases = [
  {
    arr: [100, 4, 200, 1, 3, 2],
  },
  {
    arr: [0, 3, 7, 2, 5, 8, 4, 6, 0, 1],
  },
  {
    arr: [0, 3, 7, 22, 5, 8, 4, 6, 0, 1],
  },
  {
    arr: [0, 3, 77, 2, 5, 8, 4, 6, 0, 1],
  },
  {
    arr: [100, 5, 200, 1, 3, 2],
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);

    for (let test of testCases) {
      const { arr } = test;
      let outcome1 = output()(arr);
      let outcome2 = Solution(arr);
      const result = outcome1 === outcome2;
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
